import { FieldPath } from '@form-ts/core';
import React, { memo } from 'react';
import { FormattedMessage } from 'src/migration/react-intl';
import { CommentIcon } from 'src/modules/common/icons/CommentIcon';
import { TextAreaField } from 'src/modules/form/components/TextAreaField';
import { FormError } from 'src/modules/form/types/FormError';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';

type Props = {
  readonly path: FieldPath<HvacFormData, FormError, string>;
  readOnly: boolean;
};

export const HvacSettingsCommentCardView = memo(({ path, readOnly }: Props) => (
  <div className="bp-hvac-settings-view__card bp-hvac-settings-view__card--column-2">
    <div className="bp-hvac-settings-view__card-header">
      <div className="bp-hvac-settings-view__card-icon">
        <CommentIcon/>
      </div>

      <div className="bp-hvac-settings-view__card-title">
        <FormattedMessage id="hvac/settings/comment/title"/>
      </div>
    </div>

    <div className="bp-hvac-settings-view__card-section bp-hvac-settings-view__card-section-comment">
      <div className="bp-hvac-settings-view__card-description">
        <FormattedMessage id="hvac/settings/comment/description"/>
      </div>

      <TextAreaField
        label={(
          <div className="bp-hvac-settings-view__card-energy-electrical-label">
            <FormattedMessage id="hvac/settings/comment/label"/>
          </div>
        )}
        field={path}
        maxLength={280}
        autoComplete="off"
        readOnly={readOnly}
      />
    </div>
  </div>
));
